import { useState } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import kykensAsset from "@/assets/kykens.png";
import skaapieAsset from "@/assets/skaapie.png";
import tuinAsset from "@/assets/tuin.png";

const galleryImages = [
  {
    src: "https://storage.readdy-site.link/project_files/613593af-90e6-4fd5-9a7c-ed9cd3136aa5/f06bb519-9f19-4ef7-b5df-3eb368334498_beter-ingang-erf.png?v=a53a7ee62787ade263687d2ac6f7f385",
    alt: "Farm entrance at Rietkuil",
  },
  {
    src: "https://storage.readdy-site.link/project_files/613593af-90e6-4fd5-9a7c-ed9cd3136aa5/43d502ee-fde1-4fbb-8f1a-e4d044969b74_door-enter.png?v=d8668f019569e565c8d97bd726357b1b",
    alt: "Entrance door to the farmhouse",
  },
  {
    src: "https://storage.readdy-site.link/project_files/613593af-90e6-4fd5-9a7c-ed9cd3136aa5/7eb90952-4fd2-4a06-a42b-18137f8e030e_ingang.png?v=e0689543a7742c1ddedbc66fdea8a7be",
    alt: "Main entrance to the farm",
  },
  {
    src: "https://storage.readdy-site.link/project_files/613593af-90e6-4fd5-9a7c-ed9cd3136aa5/cb6ab752-135b-4832-93af-1055abc3e7d9_sit-kamer-groen-bank.png?v=e9264efc25c1882014dbf5cb5bea023b",
    alt: "Sitting room with green couch",
  },
  {
    src: "https://storage.readdy-site.link/project_files/613593af-90e6-4fd5-9a7c-ed9cd3136aa5/a1b0b13b-3fc0-48c8-9a83-4e67e2acbe5a_sit-kamer-bank.png?v=d97c9fc02154cf8e2da52c315bd4fdd9",
    alt: "Sitting room with couch",
  },
  {
    src: "https://storage.readdy-site.link/project_files/613593af-90e6-4fd5-9a7c-ed9cd3136aa5/62dfccc3-b42b-42ff-81ab-dd55b9abfadc_7b259115-6619-45ef-9b34-20e86d72e8f7.png?v=be1e05c7ad7f7164f4a3e080b6d15472",
    alt: "Farm view at Rietkuil",
  },
  {
    src: "https://storage.readdy-site.link/project_files/613593af-90e6-4fd5-9a7c-ed9cd3136aa5/ca43ff54-9b1c-49f8-b42f-0ad8879064ea_gng.png?v=8127f978776fc293b7606ac4eddba347",
    alt: "Gate entrance at Rietkuil",
  },
  { src: kykensAsset, alt: "Hen with chicks on the farm" },
  { src: skaapieAsset, alt: "Sheep and lamb in the pasture" },
  { src: tuinAsset, alt: "Vegetable garden with cabbages" },
];

export default function Gallery() {
  const ref = useScrollReveal();
  const [lightbox, setLightbox] = useState<number | null>(null);

  return (
    <section id="gallery" ref={ref} className="overflow-hidden" style={{ backgroundColor: "#F0EBE0" }}>

      {/* Header */}
      <div className="max-w-7xl mx-auto px-8 md:px-16 pt-28 pb-16">
        <div className="flex flex-col md:flex-row md:items-center gap-0">
          <div className="md:w-1/2 pr-10 md:pr-16">
            <h2 className="fade-in font-serif font-medium leading-none" style={{ fontSize: "clamp(3.5rem, 7vw, 6.5rem)", color: "#3C3530" }}>
              The House
            </h2>
          </div>
          <div className="hidden md:block w-px self-stretch" style={{ backgroundColor: "#C8C0B4", minHeight: "6rem" }}></div>
          <div className="md:w-1/2 pl-10 md:pl-16 pt-6 md:pt-0">
          </div>
        </div>
      </div>

      {/* Row 1: wide + portrait */}
      <div className="max-w-7xl mx-auto px-8 md:px-16 mb-3">
        <div className="flex flex-col md:flex-row gap-3 items-stretch">
          <div className="img-reveal md:w-[65%] overflow-hidden" style={{ height: "500px" }}>
            <img alt={galleryImages[0].alt} className="w-full h-full object-cover object-center img-washed hover:scale-103 transition-transform duration-1000 cursor-pointer"
              src={galleryImages[0].src} onClick={() => setLightbox(0)} />
          </div>
          <div className="img-reveal delay-200 md:w-[35%] overflow-hidden" style={{ height: "500px" }}>
            <img alt={galleryImages[1].alt} className="w-full h-full object-cover object-top img-washed hover:scale-103 transition-transform duration-1000 cursor-pointer"
              src={galleryImages[1].src} onClick={() => setLightbox(1)} />
          </div>
        </div>
      </div>

      {/* Row 2: three — house entrance, outdoor trees, couch */}
      <div className="max-w-7xl mx-auto px-8 md:px-16 mb-3">
        <div className="flex flex-col md:flex-row gap-3">
          <div className="img-reveal md:w-[28%] overflow-hidden" style={{ height: "340px" }}>
            <img alt={galleryImages[2].alt} className="w-full h-full object-cover object-center img-washed hover:scale-103 transition-transform duration-1000 cursor-pointer"
              src={galleryImages[2].src} onClick={() => setLightbox(2)} />
          </div>
          <div className="img-reveal delay-100 md:w-[44%] overflow-hidden" style={{ height: "340px" }}>
            <img alt={galleryImages[5].alt} className="w-full h-full object-cover object-center img-washed hover:scale-103 transition-transform duration-1000 cursor-pointer"
              src={galleryImages[5].src} onClick={() => setLightbox(5)} />
          </div>
          <div className="img-reveal delay-200 md:w-[28%] overflow-hidden" style={{ height: "340px" }}>
            <img alt={galleryImages[4].alt} className="w-full h-full object-cover object-center img-washed hover:scale-103 transition-transform duration-1000 cursor-pointer"
              src={galleryImages[4].src} onClick={() => setLightbox(4)} />
          </div>
        </div>
      </div>

      {/* Row 3: two images + quote */}
      <div className="max-w-7xl mx-auto px-8 md:px-16 mb-3">

        <div className="flex flex-col md:flex-row gap-3 items-stretch">
          <div className="img-reveal md:w-[40%] overflow-hidden" style={{ height: "400px" }}>
            <img alt={galleryImages[3].alt} className="w-full h-full object-cover object-center img-washed hover:scale-103 transition-transform duration-1000 cursor-pointer"
              src={galleryImages[3].src} onClick={() => setLightbox(3)} />
          </div>
          {/* Quote */}
          <div className="fade-in md:w-[25%] flex items-center justify-center px-8 py-12" style={{ backgroundColor: "#F0EBE0" }}>
            <div className="text-center">
              <div className="w-5 h-px mx-auto mb-7" style={{ backgroundColor: "#A8B09E" }}></div>
              <p className="font-serif font-light leading-relaxed italic" style={{ fontSize: "1.1rem", color: "#6E5E40" }}>
                &ldquo;That you may also aspire to lead a quiet life, to mind your own business, and to work with your own hands, as we commanded you&rdquo;
              </p>
              <p className="font-sans font-light tracking-[0.1em] uppercase mt-3" style={{ fontSize: "0.75rem", color: "#7E7265" }}>
                1 Thes 4:11
              </p>
              <div className="w-5 h-px mx-auto mt-7" style={{ backgroundColor: "#A8B09E" }}></div>
            </div>
          </div>
          <div className="img-reveal delay-200 md:w-[35%] overflow-hidden" style={{ height: "400px" }}>
            <img alt={galleryImages[6].alt} className="w-full h-full object-cover object-top img-washed hover:scale-103 transition-transform duration-1000 cursor-pointer"
              src={galleryImages[6].src} onClick={() => setLightbox(6)} />
          </div>
        </div>
      </div>

      {/* Row 4: three farm life photos */}
      <div className="max-w-7xl mx-auto px-8 md:px-16 mb-28">
        <div className="flex flex-col md:flex-row gap-3">
          {[7, 8, 9].map((i, idx) => (
            <div key={i} className={`img-reveal ${idx === 1 ? "delay-100" : idx === 2 ? "delay-200" : ""} md:w-1/3 overflow-hidden`} style={{ height: "400px" }}>
              <img alt={galleryImages[i].alt} className="w-full h-full object-cover object-center img-washed hover:scale-103 transition-transform duration-1000 cursor-pointer"
                src={galleryImages[i].src} onClick={() => setLightbox(i)} />
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90" onClick={() => setLightbox(null)}>
          <div className="w-full h-full flex items-center justify-center p-4 md:p-12">
            <img
              src={galleryImages[lightbox].src}
              alt={galleryImages[lightbox].alt}
              className="max-w-full max-h-full object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <button className="absolute top-4 right-4 md:top-8 md:right-8 text-white/80 hover:text-white transition-colors w-10 h-10 flex items-center justify-center"
            onClick={() => setLightbox(null)}>
            <i className="ri-close-line text-3xl"></i>
          </button>
          <button className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors w-10 h-10 flex items-center justify-center"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox - 1 + galleryImages.length) % galleryImages.length); }}>
            <i className="ri-arrow-left-line text-2xl"></i>
          </button>
          <button className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors w-10 h-10 flex items-center justify-center"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox + 1) % galleryImages.length); }}>
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>
        </div>
      )}

    </section>
  );
}